import { render } from "./Header.vue?vue&type=template&id=7139e7a3"
import script from "./Header.js?vue&type=script&lang=js"
export * from "./Header.js?vue&type=script&lang=js"

import "./Header.scss?vue&type=style&index=0&lang=scss"
/* custom blocks */
import block0 from "./Header.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fpresentation%2Ffashion%2FHeader%2FHeader.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__